import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { FormatStringPipe } from '@shared/format-string/format-string.pipe';
import { SafePipe } from '@shared/safe/safe.pipe';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-result-count',
    templateUrl: './result-count.component.html',
    styleUrls: ['./result-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, SafePipe, FormatStringPipe, TranslateSafePipe]
})
export class ResultCountComponent {
    @Input()
    public total?: number;

    @Input()
    public searchTerm?: string;
}
